import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { splitLangPath, withLang, type SiteLang } from "./lib/lang-url";

export const getRouter = () => {
  const queryClient = new QueryClient();

  // The language the visitor's address asks for. English has no prefix.
  // Held on this instance because the server builds one router per request,
  // so two visitors reading different languages never read each other's value.
  let lang: SiteLang = "en";

  const router = createRouter({
    routeTree,
    context: { queryClient, getLang: () => lang },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    rewrite: {
      // Address -> path the router matches: /pt/works becomes /works here.
      input: ({ url }) => {
        const split = splitLangPath(url.pathname);
        // An address without a prefix is English, so a reused router never keeps an old language.
        lang = split.lang ?? "en";
        if (split.lang) url.pathname = split.pathname;
        return url;
      },
      // Path the router matches -> address: /works comes back as /pt/works.
      output: ({ url }) => {
        if (lang !== "en") url.pathname = withLang(url.pathname, lang);
        return url;
      },
    },
  });

  return Object.assign(router, {
    $lang: {
      get: (): SiteLang => lang,
      set: (next: SiteLang) => {
        lang = next;
      },
    },
  });
};
